import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "antd";
import styled from "react-emotion";
import "react-image-crop/dist/ReactCrop.css";

import * as actions from "../../../actions";
import CropImage from "./CropImage";

let canvas;
let checked = [true, true];
// --------------------------- Styles --------------
const Container = styled("div")({
  display: "flex",
  justifyContent: "space-around"
});

// -------------------------------------------------
class CroppingModal extends Component {
  state = {
    disableOkButton: false,
    croppedImageUrl: [],
    logoCrop: {
      cropOne: {
        unit: "%",
        width: 100,
        aspect: 1 / 1
      },
      cropFour: {
        unit: "%",
        width: 100,
        aspect: 4 / 1
      }
    },
    imageCrop: {
      cropOne: {
        unit: "%",
        width: 100,
        aspect: 1 / 1
      },
      cropFour: {
        unit: "%",
        width: 100,
        aspect: 1.91 / 1
      }
    }
  };

  getCroppedImg = (image, crop, fileName) => {
    // image.setAttribute("crossorigin", "anonymous");
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
    // return canvas.toDataURL();
    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  };

  // TODO: Move it to helpers
  async makeClientCrop(imageRef, crop, index) {
    if (imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        imageRef,
        crop,
        "newFile.jpeg"
      );
      const value = [...this.state.croppedImageUrl];
      value[index] = croppedImageUrl;
      this.setState({ croppedImageUrl: value });
    }
  }

  handleCropComplete = (imageRef, crop, index) => {
    this.makeClientCrop(imageRef, crop, index);
  };

  handleCheckBoxChange = (index, value) => {
    checked[index] = value;
    this.setState({
      disableOkButton: checked[0] === false && checked[1] === false
    });
  };

  onOk = () => {
    const { croppingMode } = this.props;
    const { uid } = this.props.image;
    const { croppedImageUrl } = this.state;
    if (croppingMode === "image")
      this.props.addCroppedImage(croppedImageUrl, uid);
    else if (croppingMode === "logo")
      this.props.addCroppedLogo(croppedImageUrl, uid);
    this.props.onCancel();
    this.props.updateImageState(uid, true);
  };

  renderBody = (image, text1, text2, crop, type) => {
    return (
      <Container>
        {type === "logo" ? (
          <CropImage
            checked={checked[0]}
            image={image}
            type={{
              name: type,
              shape: "square"
            }}
            crop={crop.cropOne}
            text={text1}
            index={0} // remove this props
            onCropComplete={this.handleCropComplete}
            onCheckBoxChange={this.handleCheckBoxChange}
            croppedImageUrl={this.state.croppedImageUrl[0]}
          />
        ) : null}
        {type === "image" ? (
          <CropImage
            checked={checked[1]}
            image={image}
            type={{
              name: type,
              shape: "landscape"
            }}
            crop={crop.cropFour}
            text={text2}
            index={1} // remove this props
            onCropComplete={this.handleCropComplete}
            onCheckBoxChange={this.handleCheckBoxChange}
            croppedImageUrl={this.state.croppedImageUrl[1]}
          />
        ) : null}

        {canvas}
      </Container>
    );
  };

  render() {
    const { image, onCancel, croppingMode } = this.props;
    const { logoCrop, imageCrop, disableOkButton } = this.state;
    return (
      <Modal
        visible={true}
        onOk={this.onOk}
        onCancel={onCancel}
        width="650px"
        title={`Crop your ${croppingMode}`}
        style={{ top: 150 }}
        bodyStyle={{ height:'fit-content', padding: "35px" }}
        footer={[
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>,
          <Button
            key="Save"
            type="primary"
            onClick={this.onOk}
            disabled={disableOkButton}
          >
            Continue
          </Button>
        ]}
      >
        {croppingMode === "logo"
          ? this.renderBody(
              image,
              "Use Logo (1:1)",
              "Use Logo (4:1)",
              logoCrop,
              "logo"
            )
          : this.renderBody(
              image,
              "Use square (1:1)",
              "Use landscape (1.91:1)",
              imageCrop,
              "image"
            )}
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(CroppingModal);
